import React from "react";
import background from "../../images/background-optimised.jpg";
import Footer from "../../shared/components/Footer";
import "./CustomScrollbar.css"; // Import custom scrollbar styles
import seadboxlogo from "../../images/about-the-project-sead-logo.png";
// import primarypartnerlogos from "../../images/about-primary-partners-logos.png";
// import nationalpartnerlogos from "../../images/about-national-partners-logos.png";
// import technicalpartnerlogos from "../../images/about-technical-partners-logos.png";
import primarypartnerlogos from "../../images/about/back_partner_logo_1.png";//Primary
import nationalpartnerlogos from "../../images/about/back_partner_logo_2.png";// National
import metropartnerlogos from "../../images/about/back_partner_logo_3.png";// Metro
import donorpartnerlogos1 from "../../images/about/back_partner_logo_4.png";// Donor
import donorpartnerlogos2 from "../../images/about/back_partner_logo_5.png";// Donor
import technicalpartnerlogos1 from "../../images/about/back_partner_logo_6.png";// Technical
import technicalpartnerlogos2 from "../../images/about/back_partner_logo_7.png";// Technical

const AboutUs = () => {
  // console.log("AboutUs component rendered");
  return (
    <div className="relative">
      <div
        style={{
          height: "calc(100vh - 80.88px)",
          backgroundImage: `url(${background})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative" // Ensure positioning context
        }}
        className="flex flex-col justify-between"
      >
        {/* Background overlay for consistency with other pages */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Custom scrollbars are causing errors, using native scrolling instead */}
        <div style={{
          width: "100%",
          height: "100%",
          overflowY: "auto",
          scrollbarWidth: "auto", // Changed from "thin" to "auto" for thicker scrollbars
          scrollbarColor: "rgba(255,255,255,0.5) transparent",
          position: "relative",
          zIndex: 1 // Set to 1 to be above the overlay but not compete with navbar
        }}
        className="custom-scrollbar" // Added class for additional styling
        >
          <div className="flex flex-col items-center z-10 p-5 pb-20">
            <h1 className="text-7xl text-white p-8">ABOUT THE PROJECT</h1>
            <div className="bg-white bg-opacity-100 rounded p-6 border-0 flex flex-col items-center" style={{ width: "80%" }}>
              <p className="font-sans m-10">
                <img style={{ width: "230px" }} src={seadboxlogo} alt="Sead vertical unboxed logo" />
              </p>
              <h3
                style={{
                  fontSize: 16,
                  color: "grey",
                  width: "80%",
                  textAlign: "left",
                  fontWeight: "bold",
                }}
                className="font-sans"
              >
                Why spatial economic data?
              </h3>
              <p style={{ color: "grey", width: "80%" }} className="font-sans">
                There are serious deficiencies in the coverage and quality of spatial economic data in South Africa. This is a handicap for policymakers and government officials who lack reliable information on which to base crucial decisions. Robust data is also essential for monitoring changing economic conditions and sectoral and spatial shifts over time. A lack of reliable data is also a handbrake on research (and advocacy) about the important role of cities in economic development. The
                socio-spatial legacy of apartheid continues to undermine the performance of South Africa’s cities and regions. There is a serious risk that the country’s economic problems are misdiagnosed without a spatial lens.
              </p>
              <h3
                style={{
                  fontSize: 16,
                  color: "grey",
                  width: "80%",
                  textAlign: "left",
                  fontWeight: "bold",
                }}
                className="font-sans"
              >
                A breakthrough mining tax records
              </h3>
              <p style={{ color: "grey", width: "80%" }} className="font-sans">
                The Human Sciences Research Council and National Treasury: City Support Programme entered into a partnership in July 2021 in order to plug this gap in the availability and accessibility of spatial economic data. This helped contribute to a key breakthrough in spatial economic data for the country: the mining of administrative tax records into a Spatial Tax Panel. This was possible through the support and close collaboration of the South African Revenue Services, UNU-WIDER (who
                manage a Secure Data Facility for tax data at the National Treasury) and Statistics South Africa.
              </p>
              <h3
                style={{
                  fontSize: 16,
                  color: "grey",
                  width: "80%",
                  textAlign: "left",
                  fontWeight: "bold",
                }}
                className="font-sans"
              >
                A broader programme of work
              </h3>
              <p style={{ color: "grey", width: "80%" }} className="font-sans">
                These efforts have culminated in the launch of ‘Spatial Economic Activity Data: South Africa’ (SEADsa) which is a consortium of stakeholders who share a common interest in understanding the spatial economy of South Africa. The programme continues to pioneer work in this domain including administrative data mining (including adding new sources), applied research, peer-to-peer learning, data training as well as advocacy for a focus on city regions and the spatial economy.
              </p>
              <p style={{ color: "grey", width: "80%" }} className="font-sans">
                The spatial tax portal was launched in 2023.
              </p>

              <h2
                style={{
                  fontSize: 38,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
                className="font-sans m-10 mt-20"
              >
                PARTNERS
              </h2>
              <h3
                style={{
                  fontSize: 18,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "1px solid grey",
                  lineHeight: "0.1em",
                }}
                className="font-sans m-10 mt-20"
              >
                <span
                  style={{
                    background: "#fff",
                    padding: "0 10px",
                  }}
                >
                  Primary
                </span>
              </h3>
              <div style={{ color: "grey", textAlign: "center", width: "80%", margin: "20px auto", padding: "0 6%" }} className="font-sans">
                <img style={{ width: "100%" }} src={primarypartnerlogos} alt="Primary Partners logos" />
              </div>
              <h3
                style={{
                  fontSize: 18,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "1px solid grey",
                  lineHeight: "0.1em",
                }}
                className="font-sans m-10 mt-20"
              >
                <span
                  style={{
                    background: "#fff",
                    padding: "0 10px",
                  }}
                >
                  National
                </span>
              </h3>
              <div style={{ color: "grey", textAlign: "center", width: "80%", margin: "20px auto", padding: "0 6%" }} className="font-sans">
                <img style={{ width: "100%" }} src={nationalpartnerlogos} alt="National Partners logos" />
              </div>
              <h3
                style={{
                  fontSize: 18,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "1px solid grey",
                  lineHeight: "0.1em",
                }}
                className="font-sans m-10 mt-20"
              >
                <span
                  style={{
                    background: "#fff",
                    padding: "0 10px",
                  }}
                >
                  Metro
                </span>
              </h3>
              <div style={{ color: "grey", textAlign: "center", width: "80%", margin: "20px auto", padding: "0 6%" }} className="font-sans">
                <img style={{ width: "100%" }} src={metropartnerlogos} alt="Metro Partners logos" />
              </div>
              <h3
                style={{
                  fontSize: 18,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "1px solid grey",
                  lineHeight: "0.1em",
                }}
                className="font-sans m-10 mt-20"
              >
                <span
                  style={{
                    background: "#fff",
                    padding: "0 10px",
                  }}
                >
                  Donor
                </span>
              </h3>
              <div style={{ color: "grey", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "flex-start", width: "80%", margin: "20px auto", gap: "20px", padding: "0 6%" }} className="font-sans">
                <img style={{ width: "48%" }} src={donorpartnerlogos1} alt="Donor Partners logos 1" />
                <img style={{ width: "48%", marginTop: "20px" }} src={donorpartnerlogos2} alt="Donor Partners logos 2" />
              </div>
              <h3
                style={{
                  fontSize: 18,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "1px solid grey",
                  lineHeight: "0.1em",
                }}
                className="font-sans m-10 mt-20"
              >
                <span
                  style={{
                    background: "#fff",
                    padding: "0 10px",
                  }}
                >
                  Technical (builders of this portal)
                </span>
              </h3>
              <div style={{ color: "grey", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", width: "80%", margin: "20px auto", gap: "60px", padding: "0 6%" }} className="font-sans">
                <img style={{ width: "38.4%" }} src={technicalpartnerlogos1} alt="Technical Partners logos 1" />
                <img style={{ width: "30.24%" }} src={technicalpartnerlogos2} alt="Technical Partners logos 2" />
              </div>

              <h2
                style={{
                  fontSize: 38,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
                className="font-sans m-20"
              >
                CONTACT
              </h2>
             
              <h3
                style={{
                  fontSize: 18,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "1px solid grey",
                  lineHeight: "0.1em",
                }}
                className="font-sans m-10 mt-20"
              >
                <span
                  style={{
                    background: "#fff",
                    padding: "0 10px",
                  }}
                >
                  Technical support and Feedback
                </span>
              </h3>
              <p style={{ color: "grey", textAlign: "center", width: "80%" }} className="font-sans">
                Email <a href="mailto:team@spatialtaxdata.org.za?subject=Technical support and Feedback: Spatial Tax Data Website - About us">team@spatialtaxdata.org.za</a>
              </p>

                            <h3
                style={{
                  fontSize: 18,
                  color: "grey",
                  width: "80%",
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "1px solid grey",
                  lineHeight: "0.1em",
                }}
                className="font-sans m-10 mt-20"
              >
                <span
                  style={{
                    background: "#fff",
                    padding: "0 10px",
                  }}
                >
                  SEAD-SA Newsletter
                </span>
              </h3>

              <p style={{ color: "grey", textAlign: "center", width: "80%" }} className="font-sans">
                <a href="https://galeboeservices.everlytic.net/public/forms/h/XhCGLpXkIeXYSR1e/NzYyZDFiOWI2N2ExOGQzNzlhZmUwMWM1YjU0MGExNWM0MGIyNzM5Yw==">Sign-up here</a>
              </p>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
